import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={item.cover}
          alt={`${item.title}（${item.year}）影视封面`}
          title={`${item.title} ${item.genres.join(" ")} 在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-500 text-background-950">
          {item.quality}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-0.5 text-xs font-700 text-accent-400">
          <i className="ri-star-fill text-xs" aria-hidden="true"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-background-50 to-background-50/0 p-3 pt-8 transition-transform duration-300 group-hover:translate-y-0">
          <span className="flex items-center justify-center gap-1 rounded-md bg-primary-500 py-2 text-xs font-500 text-background-950">
            <i className="ri-play-circle-line text-base" aria-hidden="true"></i>
            查看详情
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="truncate text-sm font-700 text-foreground-950 transition-colors group-hover:text-primary-400">
          {item.title}
        </h3>
        <p className="truncate text-xs text-foreground-500">{item.genres.slice(0, 3).join(" · ")}</p>
        <div className="mt-1 flex items-center justify-between text-xs text-foreground-400">
          <span>{item.year}</span>
          <span className="truncate">{item.region}</span>
        </div>
      </div>
    </Link>
  );
}